import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { displayname } from 'src/app/Models/displayname';
import { email } from 'src/app/Models/update';
import { UserItem } from 'src/app/Models/Users';
import { AuthenticationService } from 'src/app/Services/authentication.service';
import { UserStateService } from 'src/app/Services/commonservice.service';
import { CustomToasterServiceService } from 'src/app/Services/custom-toaster-service.service';
import { UsersService } from 'src/app/Services/users.service';

@Component({
  selector: 'app-personaldetails',
  templateUrl: './personaldetails.component.html',
  styleUrls: ['./personaldetails.component.css']
})
export class PersonaldetailsComponent implements OnInit {
@ViewChild('closeBtn') closeBtn!: ElementRef;
@ViewChild('closeBtn2') closeBtn2!: ElementRef;
@ViewChild('closeBtn3') closeBtn3!: ElementRef;
@ViewChild('closeBtn4') closeBtn4!: ElementRef;
  remove:boolean=true
  errorimg:boolean=false
  addimage:boolean=false
  update:boolean=false
  removebtn:boolean=true
  successimg:boolean=false
  updatemsg:boolean=false
  editemail:boolean=true
  imgshow:boolean=false
  confirm:boolean=false
  updatedisplayname:boolean=false
  usermail:string=''
  UserId:number=0
  otpValue: string = '';
  emailerrormsg:string='';
   otpemailerrormsg:string|null=null
  otperrormsg:string='';
  username:string=''
  userprofile:string=''
  showcode:boolean=false
  profile:boolean=true
  uprofile:string=''
  showimgsuccess:boolean=false
lastname:string=''
displaynames:string=''
showResendButton:boolean=false
profileImage: string | null = null;
profileurl:string|null=null
//  user: Partial<UsersInfo> = {};
 selectedFile: File | null = null;
emails:email=
{
  email:'',
  userId:0,
  code:'',
  error:''
}
resendDisabled: boolean = true;
resendTimer: number = 45;
timerInterval: any;

displayNameu:string|null=''
fillerror:string=''

displaynameupdate:displayname=
{
  userid:0,
  displayName:''
}

user:UserItem=
{
   userId:0,
       firstName:'',
       lastName:'',
       profilePhotoUrl:'',
       gender: '',
      roleId: 0,
      email: '',
      createdAt:"",
      avgRating:0,
      isDeactivate:false,
      displayName:'',
     tourGuideUserId:0,
      tourGuideId:0,
     imageUrl:''
      ,
  dialCode: '',
  phoneNumber: '',
  country: '',  
  countryCode: '',    
}

  constructor(private updateservice:AuthenticationService,
    private userservice:UsersService,
   private toasterService:CustomToasterServiceService,private userStateService:UserStateService)
  {

  }



  otpConfig = {
    length: 6,
    inputClass: 'otp-input',
    allowNumbersOnly: true
  };
  


startResendTimer(): void {

  this.resendDisabled = true;
  this.resendTimer = 45;
  this.showResendButton = false; // Initially hide the button

  if (this.timerInterval) {
    clearInterval(this.timerInterval);
   
  }

  this.timerInterval = setInterval(() => {
    this.resendTimer--;

    if (this.resendTimer <= 0) {
      clearInterval(this.timerInterval);
      this.resendDisabled = false;
      this.showResendButton = true; // Show resend button now
    }
  }, 1000);
}

  ngOnInit(): void {
     this.userStateService.profileImage$.subscribe((img) => {
    this.profileImage = img ;
  });
this.setUserData();

 this.userStateService.displayName$.subscribe(name => {

  this.displayNameu=name
});

}


setUserData() {    const storedData = sessionStorage.getItem('userData');
      const newProfilePhoto = sessionStorage.getItem('ProfileImage');
  if (storedData) {
  const parsedData = JSON.parse(storedData);

  this.usermail  = parsedData.email;
  this.UserId=parsedData.userId;
  this.username=parsedData.firstName
  this.lastname=parsedData.lastName
  this.user.profilePhotoUrl=parsedData.profilePhotoUrl
 
  
  this.user.profilePhotoUrl = newProfilePhoto ?? parsedData.profilePhotoUrl;
  


  }}

  onOtpChange(otp: string) {

  
     this.otpValue = otp;

  }
  

removeimg()
{
  this.remove=false
  this.errorimg=true
  this.addimage= true
  this.update=false
  this.removebtn=false
}
updateimg()
{
  this.update=true
  this.remove=true
  this.errorimg=false
  this.addimage= false
  this.removebtn=false
   
}

successimgs()
{
 
}

updatemsgshow()
{
  this.updatemsg=true
  this.showimgsuccess=true
}

emailverify() { 
  
 
  this.fillerror = '';
  this.emailerrormsg = '';

  if (this.emails.email) {
    if (this.emails.email !== this.usermail) {
      debugger;
      this.emails.userId = this.UserId;
      this.emails.code = this.otpValue;
   this.startResendTimer();
      this.editemail = false;
      this.confirm = true;

      this.updateservice.verifyOtp(this.emails).subscribe((res) => {
        
      });
    } else {
      this.emailerrormsg = 'Enter New Email';
    }
  } else {
    this.fillerror = 'Please enter email';
  }
}


resendotp()
{
this.startResendTimer()
 this.emailverify()
 
}



onEmailChange() {
  this.fillerror = '';
  this.emailerrormsg = '';
}
 emailerrormsges() {
  if (this.emailerrormsg) {
    this.emailerrormsg = '';
  }

  
}
otperrormsges() {
  if (this.otperrormsg) {
    this.otperrormsg = '';
  }

  
}
oonFileSelected(event: Event): void {
  const file = (event.target as HTMLInputElement).files?.[0];
  if (file) {
    const reader = new FileReader();

    reader.onload = () => {
      const base64Image = reader.result as string;
this.profileurl = reader.result as string;  // base64 image URL
      this.user.profilePhotoUrl = base64Image;
      this.selectedFile = file;

      // Optional: Show preview immediately
      
    };

    reader.readAsDataURL(file);
  }
}



showsuccesss() {
  debugger;

  this.emails.userId = this.UserId;
  this.emails.code = this.otpValue;

  this.updateservice.verifyEmails(this.emails).subscribe({
    next: (res) => {

      const storedData = JSON.parse(sessionStorage.getItem('userData') || '{}');
      storedData.email = this.emails.email;
      sessionStorage.setItem('userData', JSON.stringify(storedData));
      this.usermail = this.emails.email;

      this.imgshow = true;
      this.editemail = false;
      this.confirm = false;
       this.otpemailerrormsg =''
        this.toasterService.success("Email Updated  Successfully");
       
      setTimeout(() => {
      this.closeBtn3.nativeElement.click();
      }, 2000);
    


    
    },
    error: (err: HttpErrorResponse) => {

      this.otpemailerrormsg = err.error?.message || 'Invalid Otp.';
    }
  });
}

displayname()
{
  this.updatedisplayname=true
}
updateprofile() {
  debugger;
 this.update = true;
      this.remove = false;
    
      this.addimage = false;
      this.removebtn = false;
      this.successimg = false;
  
if (this.selectedFile) {
     this.errorimg = false;
  }
}
backemail()
{
  this.editemail=true
  this.confirm=false
  this.imgshow=false
  this.otpemailerrormsg=null
  this.otpValue=''
  this.setUserData()
  
}


backs()
{
  this.updatemsg=false
  this.showimgsuccess=false
      this.setUserData()
}


successimgupload()
{
  debugger
  if (!this.selectedFile) {
    alert('Please select a file first!');
    return;
  }

  this.userservice.uploadUserProfileImage(this.UserId, this.selectedFile).subscribe(
    (res: UserItem) => {

      


 
this.userStateService.setProfileImage( res.imageUrl);

      // Reset flags
      this.update = false;
      this.remove = false;
      this.errorimg = false;
      this.addimage = false;
      this.removebtn = false;
      this.successimg = true;
       this.profile= false;
      this.toasterService.success("Profile Photo Updated Successfully");
      
      setTimeout(() => {
      this.closeBtn.nativeElement.click();
      this.selectedFile=null;
       this.profile= true;
      }, 2000);
    


    
    },
    (error) => {
      console.error('Upload failed', error);

     
    }
  );
}




back()
{
   this.update = false;
      this.remove = true;
      this.errorimg = false;
      this.addimage = false;
      this.removebtn = true;
      this.successimg = false;
       this.profile=true;
       this.selectedFile = null; 
       this.setUserData()
     
}


updatenameapi()
{debugger
  if(this.user.firstName|| this.user.lastName){

 this.user.userId = this.UserId;

  this.userservice.Updatename(this.user.firstName, this.user.lastName, this.UserId).subscribe((res) => {
   
    const storedData = sessionStorage.getItem('userData');
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      parsedData.firstName = this.user.firstName;
      parsedData.lastName = this.user.lastName;
      this.closeBtn.nativeElement.click();
      sessionStorage.setItem('userData', JSON.stringify(parsedData));

      
      this.username = this.user.firstName;
      this.lastname=this.user.lastName
       this.toasterService.success("Admin Name Updated Successfully");
       this.user.firstName = '';
       this.user.lastName = '';
    
    }
    

    this.updatemsgshow();
    
      setTimeout(() => {
       this.closeBtn2.nativeElement.click();
      }, 2000);
    


    });
  

  }
  else
  {
     this.toasterService.error("Please make changes to Name");
  }
  ;


}
ddname=''
displaynamesupdate() {
  debugger;
  
  this.user.userId = this.UserId;
  if(!this.user.displayName || this.user.displayName.trim() === '') {
    this.toasterService.error("Please make changes to Display Name");
    return;
  }

  this.userservice.Displaynameupdate(this.UserId, this.user.displayName).subscribe((res) => {
    this.displayname(); 
    this.userStateService.setDisplayName(this.user.displayName); 
    this.toasterService.success("Display Name Updated Successfully");
                                                        
 const storedData = sessionStorage.getItem('userData');
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      parsedData.displayName = this.user.displayName;
  
      
      sessionStorage.setItem('userData', JSON.stringify(parsedData));

      
      this.ddname = this.user.displayName;
    
       this.toasterService.success("Display Name Updated Successfully");
       this.user.displayName = '';
       
      setTimeout(() => {
      this.closeBtn4.nativeElement.click();
      }, 2000);
    
    }

    this.updatemsgshow(); 
  });


}





backdisupdate()
{
  this.updatedisplayname=false
}


}
